var groups = document.querySelectorAll('.block__logos');

for (var i = 0; i < groups.length; i += 1) {
  var current = 0;
  var logos = groups[i].querySelectorAll('.block__logo');

  var cycle = function cycle() {
    logos[current].classList.remove('block__logo--active');
    if (logos[current + 1]) {
      current += 1;
    } else {
      current = 0;
    }
    logos[current].classList.add('block__logo--active');
  };

  logos[current].classList.add('block__logo--active');

  setInterval(cycle, 1000);
}

var toggle = function toggle(e) {
  var control = e.target;
  var parent = control.parentElement;
  var video = parent.querySelector('video');
  if (!video) {
    var img = parent.querySelector('img');
    var vid = document.createElement('video');
    var src = document.createElement('source');
    vid.setAttribute('playsinline', '');
    src.setAttribute('src', control.dataset.src);
    src.setAttribute('type', 'video/mp4');
    vid.appendChild(src);
    img.remove();
    parent.insertBefore(vid, control);
    video = parent.querySelector('video');
  }
  if (video.paused) {
    video.play();
    control.classList.add('block__control--playing');
  } else {
    video.pause();
    control.classList.remove('block__control--playing');
  }
};

var controls = document.querySelectorAll('.block__control');

for (var i = 0; i < controls.length; i += 1) {
  var control = controls[i];
  control.addEventListener('click', toggle);
}
